import React from "react";

import Container from '@material-ui/core/Container'

import MobileMenu from '../../Components/MobileMenu'
import DesktopMenu from '../../Components/DesktopMenu'
import menubk from '../../images/menubk.png'

const Menu = () => {
  return (
    <div className="py-4" >
      <Container maxWidth='xl'>
          <div className="d-none d-md-block">
              <DesktopMenu />
          </div>
          <div className="d-md-none">
              <MobileMenu />
          </div>
      </Container>
    </div>
  );
}

export default Menu;
